import { inject, Injectable } from '@angular/core';
import { SwUpdate, UnrecoverableStateEvent, VersionEvent } from '@angular/service-worker';
import { ToastService } from './toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from './cookie.service';

@Injectable({ providedIn: 'root' })
export class CheckForUpdateService {
    private _toastService = inject(ToastService);
    private _snackBar = inject(MatSnackBar);
    private _cookie = inject(CookieService);
    private _swUpdate = inject(SwUpdate);
    private _translate = inject(TranslateService);
    constructor() {
        this.listenForUpdates();
        this.handleUnrecoverableState();
    }

    private listenForUpdates(): void {
        this._swUpdate.versionUpdates.subscribe((evt: VersionEvent) => {
            switch (evt.type) {
                case 'VERSION_DETECTED':
                    console.log(`Nouvelle version détectée : ${evt.version.hash}`);
                    break;

                case 'VERSION_READY':
                    console.log(`Version actuelle : ${evt.currentVersion.hash}`);
                    console.log(`Nouvelle version prête : ${evt.latestVersion.hash}`);
                    this.promptUserToUpdate();
                    break;

                case 'VERSION_INSTALLATION_FAILED':
                    console.error(
                        `Échec de l'installation de la version '${evt.version.hash}':`,
                        evt.error
                    );
                    this._toastService.errori18n('COMMON.INSTALLATION_FAILED');
                    break;
            }
        });
    }

    private promptUserToUpdate(): void {
        this._snackBar
            .open(
                this._translate.instant('COMMON.NEED_UPDATE'),
                this._translate.instant('COMMON.APPLY'),
                { duration: 10000 } // 10 secondes
            )
            .onAction()
            .subscribe(() => {
                this.clearCachesAndReload();
            });
    }

    private handleUnrecoverableState(): void {
        this._swUpdate.unrecoverable.subscribe((evt: UnrecoverableStateEvent) => {
            console.error('État irrécupérable détecté :', evt.reason);
            this._snackBar.open(this._translate.instant('COMMON.NEED_REFRESH'), null, { duration: 10000 });
            setTimeout(() => this.clearCachesAndReload(), 10000);
        });
    }

    private clearCachesAndReload(): void {
        console.log('Suppression des caches et rechargement de l\'application...');
        if (this._cookie.get('registerState')) {
            this._cookie.delete('registerState');
        }

        // Supprimer tous les caches disponibles
        caches.keys()
            .then(keys => {
                return Promise.all(keys.map(key => caches.delete(key)));
            })
            .then(() => {
                // Désenregistrer les anciens service workers
                return navigator.serviceWorker.getRegistrations();
            })
            .then(registrations => {
                registrations.forEach(registration => registration.unregister());
            })
            .finally(() => {
                window.location.reload();
            });
    }
}
